<div class="flex flex-col h-full">
	<div class="flex h-full min-h-0 overflow-auto">
		<div class="w-1/4 mr-3">
			<app-radio-group
				orientation="vertical"
				[items]="searchNames"
				[ngModel]="selectedWritId"
				(ngModelChange)="onSelectSearchItem($event)"
			></app-radio-group>
		</div>
		<div class="w-9/12">
			<app-container>
				<div
					class="grid grid-cols-2 gap-4 mb-4"
					*ngIf="(selectedWrit?.writ?.names | keyvalue)?.length"
				>
					<app-input
						label="Executions number"
						type="number"
						[(ngModel)]="executionsNumber"
					></app-input>
					<app-input
						label="Name used in search"
						[(ngModel)]="searchName"
					></app-input>
				</div>

				<table
					class="dashboard-table rounded-xl border border-grey-lightest w-full"
					*ngIf="(selectedWrit?.writ?.names | keyvalue)?.length > 0"
				>
					<thead>
						<tr>
							<th class="text-left">Names</th>
							<th class="text-left">Execution No.</th>
						</tr>
					</thead>
					<tbody class="text-sm">
						<tr *ngFor="let writ of selectedWrit?.writ?.names | keyvalue">
							<td>{{ writ.value.first_name + '' + writ.value.last_name }}</td>
							<td>{{ writ.value.execution_number }}</td>
						</tr>
					</tbody>
				</table>

				<p *ngIf="!(selectedWrit?.writ?.names | keyvalue)?.length">
					No executions found
				</p>
			</app-container>
		</div>
	</div>

	<div class="flex justify-between">
		<app-button btn="tertiary" size="small" mat-dialog-close>Cancel</app-button>

		<app-button
			size="small"
			(click)="createRequisition()"
			[disabled]="!selectedWrit"
			>Create requisition</app-button
		>
	</div>
</div>
